define('views/savings/create',[
    'views/_base/baseview',
    'text!views/savings/create.html',
    'views/savings/savings_account',
    'models/causes/cause',
    'views/shared/button/button'
], function (BaseView, Template, SavingAccount, AccountModel, ButtonComponent){
    'use strict';

    var target_amount = null;

    return BaseView.extend({
        id      : 'savings-create-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'keyup .js-savings-target-amt-input' : 'handleKeyupNumberMODAL',
            'change .js-savings-target-amt-input' : 'handleBlurNumberMODAL',
            'click .js-savings-create-save-btn'  : 'saveAccountMODAL',
            'click .js-savings-create-cancel-btn': 'closeMODAL',
            'click #pf-modal-close-btn'  : 'closeMODAL'
        },
        initialize: function(options){
            options = options || {};

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            setTimeout(function(){
                that.addCreateSavingsButton();
            }, 300);

            return this;
        },

        loadData: function(){},

        addCreateSavingsButton: function(){

            this.create_savings_button = new ButtonComponent({
                // General
                elementName        : '.js-savings-create-button-container',
                calling_view       : this,
                // Transactional
                is_transaction     : false,
                // Default
                btn_label          : pf.getContent('savings_and_goals.content.create.button.label'),
                btn_callback       : this.saveAccountMODAL,
                btn_retry_callback : this.saveAccountMODAL,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : pf.getContent('savings_and_goals.content.create.button.cancel.label'),
                btn_cancel_callback: this.cancelSaveAccountMODAL,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : pf.getContent('savings_and_goals.content.create.button.success.label'),
                btn_success_message: pf.getContent('savings_and_goals.content.create.button.success.message'),
                btn_success_callback: this.accountSaveSuccessMODAL,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : pf.getContent('savings_and_goals.content.create.button.error.label'),
                btn_error_cancel_label: pf.getContent('savings_and_goals.content.create.button.cancel.label'),
                btn_error_message  : pf.getContent('savings_and_goals.content.create.button.error.message'),
                btn_error_callback : this.canceledOnError
            });

        },

        saveAccountMODAL: function(processComplete, that){
            var that = (that) ? that : this,
                name = $('.js-savings-name-input'),
                name_feedback = $('.js-savings-name-input-feedback'),
                name_valid = that.validateNameMODAL(name,name_feedback);

            if(name_valid){

                var data = {
                    account_name : _.escape(name.val())
                };
           
                $.ajax({
                    url : pf.url + '/Accounts/V2/',
                    type: 'POST',
                    data: JSON.stringify(data),
                    processData: false,
                    contentType: false,
                    success    : function(response, status){

                        if(processComplete.name){
                            that.create_savings_button[processComplete.name](true);
                        } else {
                            processComplete(true, that.create_savings_button);
                        }

                    },
                    error: function(response, status, error){

                        // if(response.responseJSON.MessageAlert != null && response.responseJSON.MessageAlert != undefined){

                        //     if(response.responseJSON.MessageAlert == "Purses unavailable"){
                                
                        //         that.create_savings_button.updateErrorMessage('Cause Space Unavailable<br/> You currently have the maximum number of active personal causes.<br/>To create a new cause, you will first have to delete an existing one.');

                        //     } else {
                                
                        //         that.create_savings_button.updateErrorMessage(response.responseJSON.MessageAlert);

                        //     }

                        // }

                        if(processComplete.name){
                            that.create_savings_button[processComplete.name](false);
                        } else {
                            processComplete(false, that.create_savings_button);
                        }

                            
                    }
                });

            } else {

                if(processComplete.name){
                    that.create_savings_button[processComplete.name](false);
                } else {
                    processComplete(false, that.create_savings_button);
                }

            }
               
        },

        accountSaveSuccessMODAL: function(resetButton, that){
            var that = (that) ? that : this;
            
            if(resetButton.name){
                that.create_savings_button[resetButton.name]();
            } else {
                resetButton(that.create_savings_button);
            }
            

            target_amount = null;

            if(pf.savings){
                pf.savings.getData();
                that.closeMODAL();

                setTimeout(function(){
                    that.closeMODAL();
                },500);
                
            }

        },

        cancelSaveAccountMODAL: function(that){
            var that = (that) ? that : this;

            that.closeMODAL();
        },

        canceledOnError: function(that){},

        handleKeyupNumberMODAL: function(e){
            var data = keyupCurrencyHandling(e);
            
            $(e.target).val(data.string);

            target_amount = Number(data.number);
        },

        handleBlurNumberMODAL: function(e){
            var data = blurCurrencyHandling(e);
            
            $(e.target).val(data.string);

            target_amount = Number(data.number);
        },

        validateNameMODAL: function(item, item_feedback){
            var isValid = true;

            // validate first name
            if(item.val() == "" || !item.val() || !(item.val().length >= 2)){
                isValid = false;
            }
            // if either first or last are invalid
            if(isValid){
                item_feedback.hide();
                return true;
            } else {
                item_feedback.html('Enter at least 2 characters');
                item_feedback.show();
                return false;
            }
        },

        closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

